import { SetInstanceOf } from './instanceof';
export const EXCLUDED_PROPERTY_NAMES = new Set(['prototype', 'constructor', ...GetOwnPropertyKeys(Object.prototype)]);
export function GetOwnPropertyKeys(target) {
    return Object.getOwnPropertyNames(target)
        .concat(Object.getOwnPropertySymbols(target));
}
export function* GetOwnPropertyDescriptors(target) {
    const keys = GetOwnPropertyKeys(target);
    for (let i = 0, l = keys.length; i < l; i++) {
        const key = keys[i];
        yield [key, Object.getOwnPropertyDescriptor(target, key), target];
    }
}
export function* GetPropertyDescriptors(target) {
    const _keys = new Set();
    while (target !== null) {
        const keys = GetOwnPropertyKeys(target);
        for (const key of keys) {
            if (!_keys.has(key)) {
                _keys.add(key);
                yield [key, Object.getOwnPropertyDescriptor(target, key), target];
            }
        }
        target = Object.getPrototypeOf(target);
    }
}
export function* GetSafePropertyDescriptors(target) {
    const iterator = GetPropertyDescriptors(target);
    let result;
    while (!(result = iterator.next()).done) {
        const [propertyName, , target] = result.value;
        if ((target !== Object.prototype)
            && (target !== Function.prototype)
            && !EXCLUDED_PROPERTY_NAMES.has(propertyName)) {
            yield result.value;
        }
    }
}
export function CopyProperties(source, destination, exclude = EXCLUDED_PROPERTY_NAMES) {
    const iterator = GetPropertyDescriptors(source);
    let result;
    while (!(result = iterator.next()).done) {
        const [propertyName, descriptor] = result.value;
        if (!exclude.has(propertyName)) {
            Object.defineProperty(destination, propertyName, descriptor);
        }
    }
}
export function CopyOwmProperties(source, destination, exclude = EXCLUDED_PROPERTY_NAMES) {
    const keys = GetOwnPropertyKeys(source);
    for (const key of keys) {
        const descriptor = Object.getOwnPropertyDescriptor(source, key);
        if ((descriptor !== void 0) && !exclude.has(key)) {
            Object.defineProperty(destination, key, descriptor);
        }
    }
}
export function CopyClassPrototype(source, destination, exclude) {
    CopyProperties(source.prototype, destination.prototype, exclude);
}
export function CopyClassStaticProperties(source, destination, exclude) {
    CopyProperties(source, destination, exclude);
}
export function CopyClassName(source, destination) {
    let descriptor = Object.getOwnPropertyDescriptor(source, 'name');
    if (descriptor === void 0) {
        descriptor = {
            configurable: true,
            enumerable: false,
            value: source.name,
            writable: false,
        };
    }
    else {
        descriptor.value = source.name;
    }
    if (descriptor.configurable) {
        Object.defineProperty(destination, 'name', descriptor);
    }
}
export function SetClassName(_class, name) {
    Object.defineProperty(_class, 'name', {
        configurable: true,
        enumerable: false,
        value: name,
        writable: false,
    });
}
export function CopyClass(source, destination) {
    CopyClassPrototype(source, destination);
    CopyClassStaticProperties(source, destination);
    SetInstanceOf(source, destination);
}
export function BindDescriptor(mapInstance, key, descriptor) {
    const _descriptor = {};
    _descriptor.configurable = descriptor.configurable;
    _descriptor.enumerable = descriptor.enumerable;
    if (typeof descriptor.value !== 'undefined') {
        let cachedFunctions = new WeakMap();
        _descriptor.get = function () {
            const instance = mapInstance(this);
            const value = Reflect.get(instance, key);
            if (typeof value === 'function') {
                if (!cachedFunctions.has(value)) {
                    cachedFunctions.set(value, value.bind(instance));
                }
                return cachedFunctions.get(value);
            }
            else {
                return value;
            }
        };
        if (descriptor.writable) {
            _descriptor.set = function (value) {
                const instance = mapInstance(this);
                Reflect.set(instance, key, value);
            };
        }
    }
    else {
        if (typeof descriptor.get === 'function') {
            _descriptor.get = function () {
                const instance = mapInstance(this);
                return descriptor.get.call(instance);
            };
        }
        if (typeof descriptor.set === 'function') {
            _descriptor.set = function (value) {
                const instance = mapInstance(this);
                return descriptor.set.call(instance, value);
            };
        }
    }
    return _descriptor;
}
export function BindDescriptorOld(instance, key, descriptor) {
    const _descriptor = {};
    _descriptor.configurable = descriptor.configurable;
    _descriptor.enumerable = descriptor.enumerable;
    if (typeof descriptor.value !== 'undefined') {
        let cachedFunction;
        let cachedFunctionWithBind;
        _descriptor.get = () => {
            if (typeof instance[key] === 'function') {
                if (cachedFunction !== instance[key]) {
                    cachedFunction = instance[key];
                    cachedFunctionWithBind = cachedFunction.bind(instance);
                }
                return cachedFunctionWithBind;
            }
            else {
                return instance[key];
            }
        };
        if (descriptor.writable) {
            _descriptor.set = (value) => {
                instance[key] = value;
            };
        }
    }
    else {
        if (typeof descriptor.get === 'function') {
            _descriptor.get = descriptor.get.bind(instance);
        }
        if (typeof descriptor.set === 'function') {
            _descriptor.set = descriptor.set.bind(instance);
        }
    }
    return _descriptor;
}
//# sourceMappingURL=helpers.js.map